import { MuiStylesType } from 'model/muiStyles.model';
import zeplinColor from 'theme/Color';

export const muiStyles: MuiStylesType = {
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '40px',
    borderRadius: '20px',
    aspectRatio: '1/1',
    backgroundColor: zeplinColor.Neutral1,
    border: `1px solid ${zeplinColor.Neutral6}`,
  },
  stylesLink: {
    border: 'none',
    backgroundColor: zeplinColor.Neutral1,
    cursor: 'pointer',
    height: '56px',
    width: '100%',
    gap: '12px',
    borderRadius: '56px',
    padding: '8px',
    textDecoration: 'none',
    color: zeplinColor.BasicBlack,

    display: 'flex',
    alignItems: 'center',

    ':hover': {
      backgroundColor: zeplinColor.Neutral3,
    },
  },
};
